import { useBrandingContext } from 'app-context/BrandingsContext';
import Modal from 'component/hoc/modal/Modal';
import React, { useEffect, useState } from 'react';
import styles from './DatePicker.module.scss';
import moment from 'moment';

function DatePicker({
  showDateModal,
  setShowDateModal,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  handleSubmitDatePicker,
}) {
  const { brandingData } = useBrandingContext();

  const [tempStartDate, setTempStartDate] = useState(
    startDate || moment().subtract(6, 'days').format('YYYY-MM-DD')
  );
  const [tempEndDate, setTempEndDate] = useState(
    endDate || moment().format('YYYY-MM-DD')
  );
  const [error, setError] = useState('');

  useEffect(() => {
    if (showDateModal) {
      setTempStartDate(
        startDate || moment().subtract(6, 'days').format('YYYY-MM-DD')
      );
      setTempEndDate(endDate || moment().format('YYYY-MM-DD'));
      setError('');
    }
  }, [showDateModal, startDate, endDate]);

  const handleSubmit = () => {
    if (moment(tempStartDate).isAfter(moment(tempEndDate))) {
      setError('Invalid date range: Start date cannot be after end date.');
      return;
    }
    setStartDate(tempStartDate);
    setEndDate(tempEndDate);
    if (handleSubmitDatePicker) {
      handleSubmitDatePicker(tempStartDate, tempEndDate);
    }
    setShowDateModal(false);
  };

  const today = new Date().toISOString().split('T')[0];

  return (
    <Modal
      title='Custom Date'
      isOpen={showDateModal}
      onClose={() => setShowDateModal(false)}
      buttonType='submit'
      onSubmit={handleSubmit}
      modalContent={{
        component: (
          <div className={styles['dates-container']}>
            <div className={styles['date-input-container']}>
              <label
                htmlFor='startDate'
                style={{ color: brandingData?.page_TextColor }}
              >
                From
              </label>
              <input
                id='startDate'
                type='date'
                value={tempStartDate}
                onChange={(e) => {
                  setTempStartDate(e.target.value);
                  if (error) setError('');
                }}
                style={{ color: brandingData?.page_TextColor }}
                max={tempEndDate || today}
              />
            </div>
            <div className={styles['date-input-container']}>
              <label
                htmlFor='endDate'
                style={{ color: brandingData?.page_TextColor }}
              >
                To
              </label>
              <input
                id='endDate'
                type='date'
                value={tempEndDate}
                onChange={(e) => {
                  setTempEndDate(e.target.value);
                  if (error) setError('');
                }}
                style={{ color: brandingData?.page_TextColor }}
                min={tempStartDate}
                max={today}
              />
            </div>

            {error ? (
              <div style={{ marginTop: 8, fontSize: 12, color: '#e03131' }}>
                {error}
              </div>
            ) : null}
          </div>
        ),
      }}
    />
  );
}

export default DatePicker;
